// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3zeGg","footer":"ModalFilter_footer__FSO3l"};